import { render, staticRenderFns } from "./VListItem.vue?vue&type=template&id=7b99b9ab&scoped=true&"
import script from "./VListItem.vue?vue&type=script&lang=js&"
export * from "./VListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b99b9ab",
  null
  
)

export default component.exports